const LOCAL_STORAGE_WISHLIST_KEY = "shopify-wishlist";
const LOCAL_STORAGE_DELIMITER = ",";
const BUTTON_ACTIVE_CLASS = "active";
const GRID_LOADED_CLASS = "loaded";

const selectors = {
  button: ".button-wishlist > button",
  grid: "[grid-wishlist]",
  productCard: ".product-content-card",
};

/* =========================
   INIT
========================= */

document.addEventListener("DOMContentLoaded", () => {
  initButtons();
  initGrid();

  const wishlist = getWishlist();

  updateWishlistCount(wishlist.length);
});

document.addEventListener(
  "shopify-wishlist:updated",
  (event) => {
    const wishlist =
      event?.detail?.wishlist || getWishlist();

    initGrid(wishlist);
  }
);

/* =========================
   FETCH PRODUCT CARD
========================= */

const fetchProductCardHTML = (handle) => {
  const url = `/products/${handle}?view=wishlist`;

  return fetch(url)
    .then((response) => response.text())
    .then((html) => {
      const documentHTML = new DOMParser().parseFromString(
        html,
        "text/html"
      );

      return (
        documentHTML.querySelector(
          selectors.productCard
        )?.outerHTML || ""
      );
    })
    .catch((error) =>
      console.error("wishlist fetch error", error)
    );
};

/* =========================
   GRID SETUP
========================= */

const setupGrid = async (
  gridElement,
  wishlist = getWishlist()
) => {
  const productCards = await Promise.all(
    wishlist.map(fetchProductCardHTML)
  );

  gridElement.innerHTML = productCards.join("");

  gridElement.classList.add(GRID_LOADED_CLASS);

  initButtons();

  if (window.initButtonsCompare) {
    window.initButtonsCompare();
  }

  if (window.wpbingo?.countdown) {
    window.wpbingo.countdown();
  }

  if (window.wpbingo?.click_atribute_image) {
    window.wpbingo.click_atribute_image();
  }

  if (
    document.querySelector(".bwp_currency") &&
    wishlist.length > 0 &&
    typeof Currency !== "undefined" &&
    Currency.Currency_customer
  ) {
    Currency.Currency_customer(true);
  }

  if (window.ajaxCart?.init) {
    window.ajaxCart.init();
  }

  document.dispatchEvent(
    new CustomEvent(
      "shopify-wishlist:init-product-grid",
      {
        detail: {
          wishlist,
        },
      }
    )
  );

  const wishlistGrid =
    document.querySelector(".wishlist__grid");

  const emptyWishlist =
    document.querySelector(".wishlist_empty");

  if (wishlistGrid) {
    wishlistGrid.classList.remove("loading_wishlist");
  }

  if (emptyWishlist) {
    if (wishlist.length > 0) {
      emptyWishlist.classList.add("hidden");
    } else {
      emptyWishlist.classList.remove("hidden");
    }
  }
};

/* =========================
   BUTTON SETUP
========================= */

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle =
      button.dataset.productHandle;

    if (!productHandle) return;

    const isActive =
      wishlistContains(productHandle);

    button.classList.toggle(
      BUTTON_ACTIVE_CLASS,
      isActive
    );

    updateButtonText(button, isActive);

    button.onclick = (event) => {
      event.preventDefault();
      event.stopPropagation();

      updateWishlist(productHandle);

      button.classList.add("load-wishlist");

      setTimeout(() => {
        button.classList.remove("load-wishlist");

        const active =
          wishlistContains(productHandle);

        button.classList.toggle(
          BUTTON_ACTIVE_CLASS,
          active
        );

        updateButtonText(button, active);
      }, 700);
    };
  });
};

const updateButtonText = (button, active) => {
  const removeText =
    window.strings?.remove_wishlist ??
    "Remove From Wishlist";

  const addText =
    window.strings?.wishlist ??
    "Add to Wishlist";

  const label = active ? removeText : addText;

  const span = button.querySelector("span");

  if (span) {
    span.textContent = label;
  }

  const wrapper = button.closest(".button-wishlist");

  if (wrapper) {
    wrapper.setAttribute("data-title", label);
  }
};

/* =========================
   INIT BUTTONS / GRID
========================= */

const initGrid = (
  wishlist = getWishlist()
) => {
  const grid =
    document.querySelector(selectors.grid);

  if (grid) {
    setupGrid(grid, wishlist);
  }
};

const initButtons = (selector) => {
  const scope = selector
    ? document.querySelector(selector)
    : document;

  if (!scope) return;

  const buttons =
    scope.querySelectorAll(selectors.button);

  if (!buttons.length) return;

  setupButtons(buttons);

  document.dispatchEvent(
    new CustomEvent(
      "shopify-wishlist:init-buttons",
      {
        detail: {
          wishlist: getWishlist(),
        },
      }
    )
  );
};

/* =========================
   WISHLIST STORAGE
========================= */

const getWishlist = () => {
  const wishlist = localStorage.getItem(
    LOCAL_STORAGE_WISHLIST_KEY
  );

  return wishlist
    ? wishlist.split(
        LOCAL_STORAGE_DELIMITER
      )
    : [];
};

const setWishlist = (wishlist) => {
  const wishlistString = wishlist.join(
    LOCAL_STORAGE_DELIMITER
  );

  if (wishlist.length) {
    localStorage.setItem(
      LOCAL_STORAGE_WISHLIST_KEY,
      wishlistString
    );
  } else {
    localStorage.removeItem(
      LOCAL_STORAGE_WISHLIST_KEY
    );
  }

  document.dispatchEvent(
    new CustomEvent(
      "shopify-wishlist:updated",
      {
        detail: {
          wishlist,
        },
      }
    )
  );

  return wishlistString;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();

  const existingIndex =
    wishlist.indexOf(handle);

  if (existingIndex === -1) {
    wishlist.push(handle);
  } else {
    wishlist.splice(existingIndex, 1);
  }

  updateWishlistCount(wishlist.length);

  return setWishlist(wishlist);
};

const updateWishlistCount = (count) => {
  const counters = document.querySelectorAll(
    "[data-count-wishlist] .count"
  );

  counters.forEach((counter) => {
    counter.innerHTML =
      count > 0 ? `${count}` : "";
  });
};

const wishlistContains = (handle) => {
  return getWishlist().includes(handle);
};

/* =========================
   WISHLIST BUY BUTTON
========================= */

class WishBuyButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = this.querySelector("form");

    if (this.form) {
      this.form.addEventListener(
        "submit",
        this.onSubmitHandler.bind(this)
      );
    }
  }

  async onSubmitHandler(event) {
    event.preventDefault();

    const submitButton =
      this.querySelector('[type="submit"]');

    if (submitButton) {
      submitButton.setAttribute(
        "aria-disabled",
        "true"
      );

      submitButton.classList.add("loading");
    }

    const formData = new FormData(this.form);

    formData.append(
      "sections",
      "cart-drawer,cart-icon-bubble"
    );

    formData.append(
      "sections_url",
      window.location.pathname
    );

    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart/add.js`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
          },
          body: formData,
        }
      );

      const responseData =
        await response.json();

      if (!response.ok) {
        throw new Error(
          responseData.description ||
            "Cart error"
        );
      }

      this.updateCartUI(
        responseData.sections
      );

      const productCard =
        this.closest(".product-card") ||
        this.closest(
          ".product-content-card"
        );

      const wishlistButton =
        productCard?.querySelector(
          ".button-wishlist button"
        );

      if (wishlistButton) {
        wishlistButton.click();
      }

    } catch (error) {
      console.error(
        "WishBuyButton Error:",
        error
      );

    } finally {
      if (submitButton) {
        submitButton.removeAttribute(
          "aria-disabled"
        );

        submitButton.classList.remove(
          "loading"
        );
      }
    }
  }

  updateCartUI(sections) {
    const cartDrawer =
      document.querySelector(
        "cart-drawer"
      );

    if (
      cartDrawer &&
      sections["cart-drawer"]
    ) {
      cartDrawer.renderContents({
        sections,
      });

      cartDrawer.classList.remove(
        "is-empty"
      );

      cartDrawer.open();
    }

    const cartBubble =
      document.querySelector(
        ".cart-icon-bubble"
      );

    const bubbleHTML =
      sections["cart-icon-bubble"];

    if (cartBubble && bubbleHTML) {
      const parser = new DOMParser();

      const parsedHTML =
        parser.parseFromString(
          bubbleHTML,
          "text/html"
        );

      const bubbleContent =
        parsedHTML.querySelector(
          ".cart-icon-bubble"
        )?.innerHTML ||
        parsedHTML.body.innerHTML;

      cartBubble.innerHTML = `(${bubbleContent})`;
    }
  }
}

if (
  !customElements.get(
    "wish-buy-button"
  )
) {
  customElements.define(
    "wish-buy-button",
    WishBuyButton
  );
}